
import React, { Component } from 'react'
import './scrollToTop.scss'

import { translation } from '../../../utils/helpers'

class ScrollToTop extends Component {
  constructor (props) {
    super(props)
    this.body = null
    this.state = {
      showGoToTop: false
    }
    this.goToTop = this.goToTop.bind(this)
    this.removeListener = this.removeListener.bind(this)
  }

  componentWillUnmount () {
    this.removeListener()
  }

  removeListener () {
    this.body.removeEventListener(this.props.elementToScrollToClassName, null)
  }

  componentDidMount () {
    this.body = document.getElementsByClassName('element-overlay')[0]

    this.body.addEventListener('scroll', () => {
      if (this.body.scrollTop > 100) {
        if (this.state.showGoToTop) return
        this.setShowTopBtn(true)
      } else {
        if (!this.state.showGoToTop) return
        this.setShowTopBtn(false)
      }
    })
  }

  setShowTopBtn (e) {
    this.setState({
      showGoToTop: e
    })
  }

  goToTop () {
    this.body.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    // this.removeListener()
    this.setState({
      showGoToTop: false
    })
  }

  render () {
    return (
      <div className='element-scrollToTop'>
        {this.state.showGoToTop && (
        <div className='scrollToTop-content' onClick={this.goToTop.bind(this)}>
          <img src='/images/svgs/go-to-top.svg' alt={translation('13025')} title={translation('13025')} />
        </div>
        )}
      </div>
    )
  }
}

export default ScrollToTop



// WEBPACK FOOTER //
// ./src/app/shared/elements/scrollToTop/index.js